const options = {
  5: "bg-green-600/5",
  10: "bg-green-600/10",
  25: "bg-green-600/25",
  50: "bg-green-600/50",
  75: "bg-green-600/75",
  90: "bg-green-600/90",
  100: "bg-green-600",
};

const from = {
  5: "from-green-600/5",
  10: "from-green-600/10",
  25: "from-green-600/25",
  50: "from-green-600/50",
  75: "from-green-600/75",
  90: "from-green-600/90",
  100: "from-green-600",
};

export default function getBackgroundGreen600(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
